export default __webpack_public_path__ + "static/1715-3a74b3ebeef10a38811b35c3c58475f8.gif";